import { Status, TextLink } from '@mm/components';
import { UICampaignItem } from '@mm/state/reducers/campaignsOverview';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import React from 'react';
import { useSelector } from 'react-redux';
import useRouter from 'use-react-router';
import { ThreeDotMenu } from '../../../../../../../common/components/ThreeDotMenu/ThreeDotMenu';
import { CHATBOT_EDITOR_RSS_FEEDS } from '../../../../../../../common/constants/routes';
import { formatDateTime } from '../../../../../../../common/helpers/formatDateTime';
import { trackWebAppGAEvent } from '../../../../../../../common/helpers/plugins/website-google-analytics';
import { useDeleteCampaign } from '../../use-delete-campaign';
import { EntityRowBaseTemplate } from '../EntityRowBaseTemplate';
import { CampaignBaseInfo, Kind } from '../SharedCells';

export type UIRssBlastStatusType = 'Active' | 'Draft' | 'Failed';

export const RssBlastRow = ({ item }: { item: UICampaignItem }) => {
  const { history } = useRouter();
  const activeChatbotId = useSelector(activeChatbotIdSelector);

  const { audienceName } = item;
  const subHeadingText = audienceName && `Audience: ${audienceName}`;

  const updatedAt = `Updated at: ${formatDateTime(item.updatedAt || '')}`;

  const itemStatus: string = item.status || '';
  let status;
  if (item.active) {
    status = 'Active';
  } else if (itemStatus === 'failed' && item.errorMessage) {
    status = 'Failed';
  } else {
    status = 'Draft';
  }

  const navigateToEditRoute = () => {
    const path = `${CHATBOT_EDITOR_RSS_FEEDS(activeChatbotId)}/edit/${item.id}`;
    history.push(path);
  };

  const onRowClick = () => {
    trackWebAppGAEvent('click', {
      category: 'campaigns_table',
      label: `table_item_rss_blast`,
    });
    navigateToEditRoute();
  };

  const { deleteCampaign } = useDeleteCampaign();
  const onSelectItem = (menuItem: string) => {
    switch (menuItem) {
      case 'edit':
        trackWebAppGAEvent('click', {
          category: 'campaigns_table',
          label: `edit_button_rss_blast`,
        });
        return navigateToEditRoute();
      case 'delete':
        return deleteCampaign(item);
      default:
        break;
    }
  };

  const elements = [
    { name: 'Edit', value: 'edit' },
    { name: 'Delete', value: 'delete' },
  ];

  const onMenuClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <EntityRowBaseTemplate
      className="starters-table__data-row starters-table__data-row--large"
      onClick={onRowClick}
      inactive={status === 'Draft'}
      key={item.id}
    >
      <CampaignBaseInfo
        headingText={item.name}
        subHeadingText={subHeadingText}
      />
      <Kind kind="rss_blasts" />

      <TextLink>{updatedAt}</TextLink>
      <Status status={status} />

      <span />
      <span />
      <span />

      <ThreeDotMenu
        className="shared_cells__menu"
        onClick={onMenuClick}
        elements={elements}
        selectItem={onSelectItem}
      />
    </EntityRowBaseTemplate>
  );
};
